'use strict';

/**
 * Initialize phone input control
 */
function initTypingOnlyInput() {
    $('.typing-only-field').each(function() {
        $(this).attr('autocomplete', 'confirm'); // autocomplete="off" doesn't work on Ms. Edge
        $(this).attr('aria-autocomplete', 'none');
        $(this).on('paste copy cut dragstart', function(e) {
            e.preventDefault();
        });
        $(this).on('focus', function() {
            $(this).removeAttr('readonly');
        });
        $(this).on('blur', function() {
            if ($(this).val().trim() === '') {
                $(this).attr('readonly', true);
            }
        });
        $(this).on('keydown', function(event) {
            if (event.ctrlKey && (event.key === 'v' || event.key === 'V')) {
                return false;
            }
        });
    });
}

module.exports = {
    initTypingOnlyInput: initTypingOnlyInput
}
